const env = "staging";

let baseUrl = '';
let companyNameIsponsorUs = '';
let sdkKeyIsponsorUs = '';
let programIdUs = '';

let companyNameIsponsorGiveShop = '';
let sdkKeyIsponsorGiveShop = '';
let programIdGiveshop = '';

let companyNamep4pUs = '';
let sdkKeyp4pUs = '';
let programIdp4pUs = '';

if(env === "staging"){
    baseUrl = "https://api.staging.pokitpal.com";
    companyNameIsponsorUs = "iSponsor US";
    sdkKeyIsponsorUs = 'pk_test_086df061-0313-45ff-bd84-94d7ab54a409';
    programIdUs = 'ea7c0b45-f361-402f-99e8-753d0ba77a94';

    companyNameIsponsorGiveShop = 'GiveShop';
    sdkKeyIsponsorGiveShop = 'pk_test_086df061-0313-45ff-bd84-94d7ab54a409';
    programIdGiveshop = 'c78c5774-044d-446b-a484-77766204206e';

    companyNamep4pUs = 'Points4Purpose';
    sdkKeyp4pUs = 'pk_test_46af612a-611c-4979-84d9-973681f6ee76';
    programIdp4pUs = '73455bda-356f-4b8a-ba8f-515c0b744b59';
}

else{
    baseUrl = "https://api.pokitpal.com";  

    companyNameIsponsorUs = 'iSponsor US';
    sdkKeyIsponsorUs = 'pk_live_2037e357-3bbb-4738-a648-b7374e7e7d2c';
    programIdUs = '929890e1-e8c3-4f88-986a-53c7a41493c8';

    companyNameIsponsorGiveShop = 'GiveShop';
    sdkKeyIsponsorGiveShop = 'pk_live_2037e357-3bbb-4738-a648-b7374e7e7d2c';
    programIdGiveshop = '3662cacf-559b-4956-8ab2-5e5ac264c423';

    companyNamep4pUs = 'Points4Purpose';
    //Replace these with correct one
    sdkKeyp4pUs = 'pk_live_73d137f5-81fc-4589-b487-654aab42e9b3';
    programIdp4pUs = 'c1544ca1-5dcc-4bc5-a802-b189bcd90bf8';
}

const registerFidel = async (form) =>{
    await fetch(`${baseUrl}/v1/FidelCards/Create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(form),
    });
}

const getProfile = (token) => {
    return  fetch( `${baseUrl}/v1/profile`, {
        method: "GET",
        headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
        },
    });
}

const enroll = async (card, cardBody, token)=>{
    var result = await fetch(
        `${baseUrl}/v1/DebitCards/enrol`,
        {
            method: "POST",
            headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                data: cardBody,
                bankCode: card.provider,
                isEncryptionOff: true,
            }),
        }
    );

    return result;
}

const getBanks = (region,token)=>{
   return fetch(`${baseUrl}/v1/Banks/?region=` + region, {
			method: "GET",
			headers: {
				Authorization: "Bearer " + token,
				"Content-Type": "application/json",
			},
		})
}

const getApplicationToken = async () => {
    return await fetch(`${baseUrl}/v1/Account/GetToken`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                clientId: "1D5EE4D9-203C-4A7C-B227-9988B5EF80E1",
                clientSecret: "LBasdrangkjhaskd2knKQcMR1234",
            }),
        })
            .then((response) => {
                if (response.status === 201) {
                    return response.json();
                } else {
                    errors = { response: "something went wrong" };
                }
            })
            .then((data) => {
                return data.token;
            });

        }	

const registerUser = async (email,bpayid, token) => {
    return await fetch(`${baseUrl}/v1/Account/Register`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            },
            body: JSON.stringify({
                email: email,
                externalId: bpayid
            }),
        })
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    errors = { response: "We couldn’t validate your email or BPAY id. Please go back and try again." };
                }
            })
            .then((data) => {
                return data.tokenDetails.token;
            });

        }	


const client = {

    enroll : enroll,
    banks : getBanks,
    registerUser: registerUser,
    getApplicationToken: getApplicationToken,
    getProfile : getProfile,
    registerFidel: registerFidel,
    giveshop : {companyNameIsponsorGiveShop, sdkKeyIsponsorGiveShop, programIdGiveshop},
    isponsorus : {companyNameIsponsorUs, sdkKeyIsponsorUs, programIdUs},
    p4pUs : {companyNamep4pUs, sdkKeyp4pUs, programIdp4pUs}
}

export {client};